/**
 * Content filter types
 * @module services/content-filters/types
 */

export const CONTENT_FILTER_TYPE_AUTHOR = 'author'
export const CONTENT_FILTER_TYPE_CENTER_TAG = 'center-tag'
export const CONTENT_FILTER_TYPE_CONSCIOUS_FORMAT = 'conscious-format'
export const CONTENT_FILTER_TYPE_CONSCIOUS_TOPIC = 'conscious-topic'
export const CONTENT_FILTER_TYPE_FILM_SUBJECT = 'film-subject'
export const CONTENT_FILTER_TYPE_FILM_TYPE = 'film-type'
export const CONTENT_FILTER_TYPE_FITNESS_DURATION = 'fitness-duration'
export const CONTENT_FILTER_TYPE_FITNESS_INSTRUCTOR = 'fitness-instructor'
export const CONTENT_FILTER_TYPE_FITNESS_LEVEL = 'fitness-level'
export const CONTENT_FILTER_TYPE_FITNESS_SPECIALTY = 'fitness-specialty'
export const CONTENT_FILTER_TYPE_FITNESS_STYLE = 'fitness-style'
export const CONTENT_FILTER_TYPE_INTERVIEW_COLLECTION = 'interview-collection'
export const CONTENT_FILTER_TYPE_INTERVIEW_GUEST = 'interview-guest'
export const CONTENT_FILTER_TYPE_INTERVIEW_HOST = 'interview-host'
export const CONTENT_FILTER_TYPE_INTERVIEW_TOPIC = 'interview-topic'
export const CONTENT_FILTER_TYPE_MEDITATION_FOCUS = 'meditation-focus'
export const CONTENT_FILTER_TYPE_MEDITATION_STYLE = 'meditation-style'
export const CONTENT_FILTER_TYPE_MEDITATION_TEACHER = 'meditation-teacher'
export const CONTENT_FILTER_TYPE_MEDITATION_DURATION = 'meditation-duration'
export const CONTENT_FILTER_TYPE_RECIPE_DIET = 'recipe-diet'
export const CONTENT_FILTER_TYPE_RECIPE_TYPE = 'recipe-type'
export const CONTENT_FILTER_TYPE_THIRD_PARTY_GENRE = 'third-party-genre'
export const CONTENT_FILTER_TYPE_YOGA_DURATION = 'yoga-duration'
export const CONTENT_FILTER_TYPE_YOGA_FOCUS = 'yoga-focus'
export const CONTENT_FILTER_TYPE_YOGA_LEVEL = 'yoga-level'
export const CONTENT_FILTER_TYPE_YOGA_STYLE = 'yoga-style'
export const CONTENT_FILTER_TYPE_YOGA_TEACHER = 'yoga-teacher'
export const CONTENT_FILTER_TYPE_YI_YOGA_CLASS_LEVEL = 'yi-yoga-class-level'
export const CONTENT_FILTER_TYPE_YI_YOGA_CLASS_STYLE = 'yi-yoga-class-style'
export const CONTENT_FILTER_TYPE_YI_USER_GOALS = 'yi-user-goals'
export const CONTENT_FILTER_TYPE_YI_COURSE_CATEGORY = 'yi-course-category'
export const CONTENT_FILTER_TYPE_YI_TAGS = 'yi-tags'
export const CONTENT_FILTER_TYPE_YI_CHANNELS = 'yi-channels'
export const CONTENT_FILTER_TYPE_YI_YOGA_CLASS_SECONDARY_STYLE = 'yi-yoga-class-secondary-style'
